import { render } from "./PresenceWrapper.vue?vue&type=template&id=0a5a0a12&scoped=true"
import script from "./PresenceWrapper.vue?vue&type=script&lang=js"
export * from "./PresenceWrapper.vue?vue&type=script&lang=js"

import "./PresenceWrapper.vue?vue&type=style&index=0&id=0a5a0a12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5a0a12"]])

export default __exports__